/**
 * 应用入口
 * 用途：创建 Vue 应用、注册路由与多语言、引入全局样式
 * 用法：npm run serve 启动后由此文件挂载到 #app
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './assets/styles/reset.css'
import './assets/styles/theme.css'

createApp(App).use(router).use(i18n).mount('#app')
